const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

export const formatDateInYYYYMMDD = (date: string) => {
    const d = new Date(date);
    let day = '' + d.getDate();
    let month = '' + (d.getMonth() + 1);
    const year = d.getFullYear();

    if(month.length < 2) month = '0' + month;
    if(day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
};

export const formatDateInDDMMYYYY = (date: string) => {
    const d = new Date(date);
    let day = String(d.getDate());
    const month = MONTHS[d.getMonth()];
    const year = d.getFullYear();

    if(day.length < 2) day = '0' + day;

    return `${month} ${day}, ${year}`;
};

export const formatDateInFrench = (date: string | undefined) => {
    if(!date) return date;

    const month = date.split(',')[0].split(' ')[0].substring(0,3);
    const day = date.split(',')[0].split(' ')[1];
    const year = date.split(',')[1].replace(' ', '');

    return `${day} ${month.toUpperCase()} ${year}`;
};

export const getUtcDate = (dateString: string) => {
    // we need to parse it differently to avoid timezone issues
    if (dateString.includes(',') && dateString.includes(' ')) {
        // Handle formatted date strings like "January 15, 2024"
        const date = new Date(dateString);
        // Use local timezone to avoid shifting
        const localDate = new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        }).format(date);
        return localDate;
    }
    
    // Handle ISO date strings (e.g., "2024-01-15")
    const date = new Date(dateString);
    
    // For ISO dates, use UTC to maintain consistency
    const utcDate = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'UTC',
    }).format(date);

    return utcDate;
};